import React from 'react';

function OngoingCampaignCardSkeleton() {
  return (
    <div className="w-[200px] lg:w-[320px] flex items-center gap-3 rounded-xl shadow-trending-categories-search">
      <div className="flex-shrink-0 w-[200px] lg:w-[320px] h-[76px] lg:h-[104px] flex items-center gap-3 animate-pulse bg-skeleton rounded-xl" />
    </div>
  );
}

export default OngoingCampaignCardSkeleton;
